<template>
<div class="plist">
    <div class="screen">
      <mt-search
        v-model="request.searchStr"
        cancel-text="取消"
        placeholder="按关键字模糊搜索"
        @input="titleSearch"
        class="font-size-8"
        style="width:calc(100% - 20px);height:auto;background:white"
        >
      </mt-search>
      <!-- <div class="time" @click="ShouPup"><img src="../../assets/49.png" /></div> -->
      <div class="clear"></div>
      <mt-navbar class="page-part" v-model="status">
        <mt-tab-item id="2">全部</mt-tab-item>
        <mt-tab-item id="0">待处理</mt-tab-item>
        <mt-tab-item id="1">已完成</mt-tab-item>
      </mt-navbar>
    </div>
    <div class="page-infinite">
        <div class="page-infinite-wrapper" >
            <ul  class="page-infinite-list" v-infinite-scroll="loadByPage" infinite-scroll-disabled="loading" infinite-scroll-distance="20" style="padding-bottom:4rem">
                <li class="page-infinite-listitem" v-for="(item,index) in loadList" :key="index" >
                    <div class="box" >
                      <div class="statusstr">{{item.status==1?'已完成':'待处理'}}</div>
                      <div class="lf" style="margin-top: 2rem;">
                        <div class="box_row" @click="GoToDetail(item)">
                            <div style="font-weight: bold;"> {{item.categoryName}}</div>
                        </div>
                        <div class="box_row" style="border-bottom: 1px solid #d2d2d3;margin-top:12px;" @click="GoToDetail(item)">
                        </div>
                      </div>
                        <div class="box_row" style="margin-top:12px;" @click="GoToDetail(item)">
                            <div class="threecontent"> {{item.customerReason}} </div>
                        </div>
                        <div class="box_row" style="margin-top: 1rem;" @click="GoToDetail(item)">
                             <div><img src="../../assets/71.png" /> {{getDateTimeStr(item.revisitTime)}} </div>
                        </div>
                        <div class="box_row">
                            <div><img src="../../assets/70.png" /> {{item.customerAddress}}  </div>
                        </div>
                        <div class="box_row">
                            <div><img src="../../assets/72.png" /> {{item.d365No}}  </div>
                        </div>
                        <div class="box_row" style="display: block;">
                            <div class="callBtnDiv">
                                <div v-if="item.status===0" class="callbtn" @click="CallCustomer(item.customerMobile)" ><img src="../../assets/57.png" />联系顾客</div>
                                <div v-if="item.status===0" class="callbtn" @click="GoToDetail(item)" style="margin-left:0.5rem;width: 4rem;text-align: center;">处理</div>
                                <div v-if="item.status===1" class="callbtn" @click="GoToDetail(item)"  style="margin-left:0.5rem;width: 4rem;text-align: center;">查看</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
         
            <div v-show="!loading" class="img" align="center" v-if="loadList.length == 0" style="margin-top: 150px;">
                <img src="@/assets/nodate.png" width="34%" alt="无数据" />
            </div>
            <p v-show="loading" class="page-infinite-loading">
                <mt-spinner type="fading-circle"></mt-spinner>加载中...
            </p>
        </div>
    </div>
</div>
</template>
<style scoped>
.threecontent{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.choose{background-color: #ea002a;}
.choose li{padding: 1.25rem ;position: relative;}
.choose li:after{content: '';position: absolute;right: 1rem;top: 2rem;left:1rem;width: 1rem;height: 0.6rem;background: url(../../assets/3.png) no-repeat;background-size: 100% 100%;}
.choose li:last-child{margin: 0;}
.choose li:last-child:after{right: initial;left: 2.3rem;top: 1.8rem;height: 0.92rem;background: url(../../assets/23.png) no-repeat;background-size: 100% 100%;}
.choose li input{background: #f2f2f2;width: 95%;border: 0;padding: 0.5rem 2rem;box-sizing: border-box;border-radius: 1rem;color:black;margin-left:0.5rem;}
.popup{
    border-radius: 2rem;
}
.jdauto{
    line-height: 12px;
    color: #fff;
    padding: 10px 2rem 10px 1rem;
    border-radius: 1rem;
    border-top-right-radius: 0;
    background: -mos-linear-gradient(to right,#f5b80f,#d9a824);
    background: linear-gradient(to right,#f5b80f,#d9a824);
    position: absolute;
    right: 0;
    z-index: 1;
}
.jdno{
    line-height: 12px;
    color: #fff;
    padding: 10px 2rem 10px 1rem;
    border-radius: 1rem;
    border-top-right-radius: 0;
    background: -mos-linear-gradient(to right,#f50f0f,#f50f0f);
    background: linear-gradient(to right,#f50f0f,#f50f0f);
    position: absolute;
    right: 0;
    z-index: 1;
}
.mint-cell:last-child{
    background-image:none !important;
}
.mint-cell-wrapper{
    background-image:none !important;
}
</style>
<script>
import { Button } from 'mint-ui';

import _ from 'lodash';
import {
    Toast,
} from 'mint-ui';
import DataTransfer from "../../common/DataTransfer";
import AttachUpload from '../../components/AttachUpload.vue';
export default {
    data() {
        return {
            CurrentEstimateOnSiteTime:'',
            currentItem:{},
            slots:[{values:['上午','下午']}],
            startDatePicker: new Date(),
            status:'0',
            scroll:0,
            title:'',
            request: {
                searchStr:'',
                pageIndex:0,
                pageSize: 5,
                Status:0,
                orderDesc:true,
            },
            MainRequest:{
                callRquestOrderNo:'',
                IsOnSiteServiceStr:"现场服务",
                CurrentEstimateOnSiteDate:'',
                CurrentEstimateOnSiteTime:'',
                Comment:'',
                WaitComfirmOnsiteTime:false
            },
            totalCount: 0,
            totalPage: 0,
            searchCount: 0,
            loading: false,
            canLoading: true,
            loadList: [],
            popupVisible:false,
            popupVisible2:false,
            popupVisible3:false,
            popupVisible4:false,
            popupVisible5:false,
            IsCheckAll: false,
            show:true,
            show2:true,
            show3:true,
            show4:true,
            show5:true,
            navList: [],
            navList2: [],
            navList3: [],
            navList4: [],
            navList5:[],
            appId:'',
            apptimestamp:'',
            appnonceStr:'',
            appsignature:'',
            latitude:0,
            longitude:0
        };
    },
    activated() {
            if(this.scroll > 0) {
                window.scrollTo(0, this.scroll); this.scroll = 0;
                window.addEventListener('scroll', this.scrollHandle);
            }
        },
        watch:{
            status(val){
                var that=this;
                if(val!=undefined){
                    that.request.Status=parseInt(val);
                    that.SearchByTitle();
                }
            }
        },
        components: {
        'attach-upload': AttachUpload,
    },
    methods: {
        
        GoToDetail(item){
            var that=this;
            that.$router.push({
                path: `/Complaint/detail?id=`+item.id
            });
        },
        ShouPup() {
        this.popupVisible4 = true
      },
      ConfirmChage(){},
      resetSelect(){
        this.IsCheckAll = false;
        this.navList.forEach(function(obj){
            obj.isActive = false;
        });
        this.navList2.forEach(function(obj){
            obj.isActive2 = false;
        });
        this.navList3.forEach(function(obj){
            obj.isActive3 = false;
        });
        this.navList4.forEach(function(obj){
            obj.isActive4 = false;
        });
        this.navList5.forEach(function(obj){
            obj.isActive5 = false;
        });
        this.request.startDate = null;
        this.request.endDate = null;
        this.startDate = new Date();
        this.endDate = new Date();
        
      },
      ShouPup2() {
        var _self = this 
        _self.popupVisible5 = true
        _self.IsCheckAll = false;
        _self.navList.forEach(function(obj) {
          obj.isActive = false
          _self.request.AccLevels.forEach(function(obj2){
            if(obj2 == obj.classItem){
              obj.isActive = true
            }
          })
        });
        _self.navList2.forEach(function(obj) {
          obj.isActive2 = false
          _self.request.AccStatus.forEach(function(obj2){
            if(obj2 == obj.classItem){
              obj.isActive2 = true
            }
          })
        });
        _self.navList3.forEach(function(obj) {
          _self.request.AccContractStatus.forEach(function(obj2){
            obj.isActive3 = false
            if(obj2 == obj.classItem){
                obj.isActive3 = true
            }
          })
        });
        _self.navList4.forEach(function(obj) {
          obj.isActive4 = false
          _self.request.ManualStatus.forEach(function(obj2){
            if(obj2 == obj.classItem){
              obj.isActive4 = true
            }
          });
        });
        _self.navList5.forEach(function(obj) {
          obj.isActive5 = false
          if(_self.request.DevelopType == obj.classItem){
            obj.isActive5 = true
          }

        });
      },
      getStatusStr(status){
        if(status==1){
            return "待处理";
        }
      },
        scrollHandle: function(e) {
            var that=this;
            var top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
            that.scroll  = document.documentElement && document.documentElement.scrollTop
            
            return false;
        },
        GoBack() {
            var that = this;
            that.$router.go(-1);
        },
        CallCustomer(mobile){
            var that=this;
            window.location.href = 'tel://' + mobile
        },
        SearchByTitle() {
            var that = this;
            that.loadList = [];
            that.request.pageIndex = 0;
            that.totalPage = 0;
            that.searchCount = 0;
            that.totalCount = 0;
            that.canLoading = true;
            that.loadByPage();
        },
        getDateTimeStr(datestr){
            var date=new Date(datestr);
            var that=this;
            return DataTransfer.dateToString(date)+' '+DataTransfer.dateToTime(date);
        },
        onValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.CurrentEstimateOnSiteTime = values[0];
            }
        },
        HandleStartDateConfirm(data) {
           var that = this;
           var date=data;
           var yes=new Date().setTime(new Date().getTime()-24*60*60*1000);
            if(date<yes){
                Toast('预计上门时间不能小于当前日期');
                return false;
            }
            that.MainRequest.CurrentEstimateOnSiteDate = DataTransfer.dateToString(data);
        },
       confirmSelect(){
          var that = this;
          that.popupVisible2 = false;
          that.MainRequest.CurrentEstimateOnSiteTime=that.CurrentEstimateOnSiteTime;
       },
        ShowStartDatePicker() {
            var that = this;
            that.$refs.startDatePicker.open();
        },
        ShowMorningPicker() {
            var that = this;
            that.popupVisible2=true;
        },
        CallCustomer(mobile){
            var that=this;
            window.location.href = 'tel://' + mobile
        },
        SearchByTitle() {
            var that = this;
            that.loadList = [];
            that.request.pageIndex = 0;
            that.totalPage = 0;
            that.searchCount = 0;
            that.totalCount = 0;
            that.canLoading = true;
            that.loadByPage();
        },
        DateTimeToDate(date){
          date=new Date(date);
          var y = date.getFullYear();  
          var m = date.getMonth() + 1;  
          m = m < 10 ? '0' + m : m;  
          var d = date.getDate();  
          d = d < 10 ? ('0' + d) : d;  
          return y + '-' + m + '-' + d;  
        },
        openSetToDoDialog(item){
            var that=this;
            that.popupVisible=true;
            that.currentItem=item;
        },
        loadByPage() {
            var that = this;
            //这是判断是否已经加载到数据结束参数
            if (!that.canLoading) {
                return;
            }
            if (that.loading) {
                return;
            }
            that.loading = true;
            that.$axios
                .get("/api/Complaint/GetByPage", {
                    params: that.request
                })
                .then((res) => {
                   that.loading = false;
                    var result = res.data;
                    if (result != null && result.isSuccess) {
                        var searchResult = result.data;
                        that.request.pageIndex = searchResult.pageIndex + 1;
                        that.totalCount = searchResult.totalCount;
                        that.totalPage = searchResult.totalPages;
                        if (that.request.pageIndex == that.totalPage || searchResult.data == null || searchResult.data.length == 0) {
                            that.canLoading = false;
                        }
                        for(var i=0;i<searchResult.data.length;i++){
                          that.loadList.push(searchResult.data[i]);
                       }
                    } else {
                        console.log(result.message);
                        that.canLoading = false;
                    }
                })
                .catch((err) => {
                    that.loading = false;
                    that.canLoading = false;
                    Toast("数据加载失败，请稍后再试");
                    console.log(err);
                });
        }
    },
    mounted() {
        var that = this;
        window.addEventListener('scroll', this.scrollHandle);  // 绑定页面的滚动事件
    },
    created() {
        var that = this;
        that.status=that.$route.query.status;
        that.request.Status=parseInt(that.status);
        that.titleSearch = _.debounce(that.SearchByTitle, 1000);
    },
};
</script>
